export enum NodeItemType {
  ArrayNode,
  ObjectNode
}
